// Import dependencies
import React from 'react';
import PropTypes from 'prop-types';
import Blazy from 'blazy';

// Components
import PageScrollAnimation from '../../../../components/PageScrollAnimation';

class SearchResult extends React.Component {
  componentDidMount() {
    this.lazyImages = new Blazy({
      selector: '.js-react-lazy',
      successClass: 'is-lazyloaded',
      errorClass: 'has-load-error',
      offset: 200,
    });

    PageScrollAnimation({
      selector: '.js-react-animate',
      eleAnimated: 'is-animated',
      mediaQuery: 900,
    });
  }

  componentDidUpdate() {
    this.lazyImages.revalidate();
  }

  componentWillUnmount() {
    this.lazyImages.destroy();
  }

  render() {
    const {
      title,
      teaser,
      url,
      imageListing,
    } = this.props;

    const image = imageListing.length > 0 ? imageListing[0].url : null;

    return (
      <div className="c-search-result  js-react-animate">
        {image && (
          <figure className="c-image u-show@medium">
            <div className="c-image__container">
              <div className="c-image__background js-react-lazy" data-src={image}>
                <picture>
                  <img className="js-lazy" data-src={image} alt="" />
                </picture>
              </div>
            </div>
          </figure>
        )}
        <div className="c-search-result__content">
          <a href={url}>
            <h4 className="c-search-result__title">{title}</h4>
            {teaser && <p className="c-search-result__teaser">{teaser}</p>}
          </a>
        </div>
      </div>
    );
  }
}

SearchResult.propTypes = {
  title: PropTypes.string.isRequired,
  teaser: PropTypes.string,
  url: PropTypes.string.isRequired,
  imageListing: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
  })),
};

SearchResult.defaultProps = {
  imageListing: [],
  teaser: null,
};

export default SearchResult;
